import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/xendora/react-timer/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import ReactTimer from '../src/index';
import ChartsExample from './charts-example';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "advanced-examples"
    }}>{`Advanced Examples`}</h1>

    <h2 {...{
      "id": "line-graph"
    }}>{`Line graph`}</h2>
    <p>{`A line graph that periodically updates itself`}</p>
    <ChartsExample mdxType="ChartsExample" />
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import React from 'react';
import { Chart } from 'react-charts';
import ReactTimer from '@xendora/react-timer';

const MyChart = () => {
  const coords = [[0, 0]];

  const axes = React.useMemo(
    () => [
      { primary: true, type: 'linear', position: 'bottom' },
      { type: 'linear', position: 'left' },
    ],
    [],
  );

  const renderChart = (value) => {
    const ar = [value, (Math.random() * 10).toFixed(0)];
    coords.push(ar);
    return (
      <Chart
        data={[
          {
            label: 'Series 1',
            data: coords,
          },
        ]}
        axes={axes}
      />
    );
  };

  return (
    <div
      style={{
        width: '100%',
        height: '300px',
      }}
    >
      <ReactTimer
        start={0}
        end={(value) => value === 10}
        onTick={(value) => value + 1}
      >
        {(value) => renderChart(value)}
      </ReactTimer>
    </div>
  );
};


export default MyChart;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      